<template>
  <div class="elevation-2 background lighten-1 pa-4 rounded" @click="onDutySelected()" style="height:150px">
    <duty-card-title show-date
                     :duty="duty"></duty-card-title>
    <duty-card-content :show-date="false"
                       :duty="duty"
                       height="3.8em"></duty-card-content>

  </div>
</template>

<script>

import dutyMixin from '../common/dutyMixin';
import commonMixin from '@/mixins/common';
import DutyCardTitle from './DutyCardTitle.vue';
import DutyCardContent from './DutyCardContent.vue';
export default {
  name: 'DutyCard',
  mixins: [dutyMixin, commonMixin],
  props: {
    duty: Object,
  },
  components: { DutyCardTitle, DutyCardContent },
  methods: {
    onDutySelected() {
      this.$router.push(`/myduties/detail/${this.duty.id}`);
    },
  },
};
</script>
